import request from '@/utils/request'
export let pic_upload = 'http://upload-z1.qiniup.com/'
export function getAuthCode(params) {
  return request({
    url: '/scan_contribution/getAuthCode',
    method: 'get',
    params
  })
}
// 获取token
export function getToken(params) {
    console.log(params)
    return request({
      url: '/scan_contribution/getToken',
      method: 'get',
      params
    })
  }
  // 新增投稿列表
  export function publish(data) {
    return request({
      url: '/scan_contribution/publish',
      method: 'post',
      data
    })
  }

  export function uploadToken() {
    return request({
      url: '/qi_niu/get_qiniu_info',
      method: 'get'
    })
  }

  export function getUserInfo() {
    return request({
      url: '/scan_contribution/getUserInfo',
      method: 'get'
    })
  }

  // 获取频道

   export function get_hot_new_channel_list_all(params) {
    return request({
      url: '/hot_news_info/get_news_channel',
      method: 'get',
      params
    })
  }
  //获取列表
  export function getpub(params) {
    return request({
      url: '/scan_contribution/getpub',
      method: 'get',
      params
    })
  }